<div [id]="id" class="flex w-full flex-col p-4">
    @if (showPagination && paginationResult && rawResults && paginationResult.nbPages > 0) {
        <span
            class="px-2 justify-start body-small-regular text-subtle"
        >
            {{paginationResult.currentRefinement * resultsPerPage + 1}} to {{Math.min(paginationResult.currentRefinement * resultsPerPage + resultsPerPage, paginationResult.nbHits)}} of {{paginationResult.nbHits}} results
        </span>
    }
    <div class="flex w-full flex-col">
        @if (algoliaRecordHits && algoliaRecordHits.length > 0) {
            <ul class="flex w-full flex-col">
                <li 
                    *ngFor="let algoliaRecordHit of algoliaRecordHits; let i = index" 
                    id="search-result-item-{{i}}"
                    class="flex w-full flex-row justify-between px-2 py-2 hover:bg-gray-300 cursor-pointer border-b border-gray-200 last:border-b-0"
                    (click)="onSelectListItem(algoliaRecordHit)">
                    
                    <a class="flex w-full hover:no-underline" 
                        [routerLink]="getSearchResultItemLink(algoliaRecordHit)"
                    >
                        <app-search-result-item
                            class="flex w-full"
                            [algoliaRecordHit]="algoliaRecordHit"
                        >
                        </app-search-result-item>
                    </a>

                    <div
                        *ngIf="i==0 && !isOnGlobalSearchPage" 
                        class="flex flex-row">
                        <a class="flex text-link hover:no-underline" 
                            [routerLink]="['/search']"
                            (click)="preventParentClick($event, algoliaRecordHit)"
                        >
                        <!-- Prevent click from propagating to parent li, which would trigger onSelectListItem and cause unwanted behavior when clicking -->
                            View all &nbsp;
                            <span class="flex icon-24 material-symbols-rounded">{{viewAllIconName}}</span>
                        </a>
                    </div>
                </li>
            </ul>
        } @else if (rawResults && rawResults.query) {
            <div class="flex w-full flex-col items-center gap-2 py-8">
                <span class="icon-40 material-symbols-rounded text-disabled">{{searchIconName}}</span>
                <span class="body-xlarge-bold">No results found</span>
                <span class="body-small regular">Try adjusting your search to find what you are looking for.</span>
            </div>
        } @else {
            <app-loading-indicator
                class="flex items-center"
            ></app-loading-indicator>
        }
    </div>

    @if (showPagination && paginationResult && rawResults && paginationResult.nbPages > 0) {
        <div class="flex justify-center items-center">
            <app-pagination
                id="global-search-paginator"
                [totalRecords]="paginationResult.nbPages * rawResults.hitsPerPage"
                [recordsPerPage]="rawResults.hitsPerPage"
                [currentPage]="paginationResult.currentRefinement + 1"
                (pageChange)="onPageChange($event)"
            >
            </app-pagination>
        </div>
    }
</div>